import React from 'react';
import { AppCheckboxFormLabel } from '@/components/atoms';

interface TreatmentReportFieldRowProps {
  labelKey: string;
  label: string;
  required?: boolean;
  checked: boolean;
  onToggle: (key: string) => void;
  children: React.ReactNode;
}

export const TreatmentReportFieldRow: React.FC<TreatmentReportFieldRowProps> = ({
  labelKey,
  label,
  required = false,
  checked,
  onToggle,
  children,
}) => (
  <>
    <div className="flex items-center gap-2">
      <AppCheckboxFormLabel
        label={label}
        required={required}
        checked={checked}
        onChange={() => onToggle(labelKey)}
        className="flex-1"
        data-skip-enter-nav
        tabIndex={-1}
      />
    </div>
    <div className="min-w-0 max-w-full">{children}</div>
  </>
);
